import React from 'react';
import { Select } from 'antd';
import { AdSource } from '../../types';

interface AdSourceSelectProps {
  value: AdSource;
  onChange: (v: AdSource) => void;
}

export function AdSourceSelect({ value, onChange }: AdSourceSelectProps) {
  return (
    <Select
      value={value}
      onChange={(v) => onChange(v as any)}
      style={{ width: "100%" }}
    >
      <Select.Option value="yandex_direct">Яндекс Директ</Select.Option>
      <Select.Option value="vk_ads">VK Реклама</Select.Option>
    </Select>
  );
}
